
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

interface PasswordSetupFormProps {
  onSubmit: (password: string) => Promise<void>;
  isSubmitting: boolean;
  isRecoveryMode: boolean;
}

export const PasswordSetupForm = ({ 
  onSubmit, 
  isSubmitting, 
  isRecoveryMode 
}: PasswordSetupFormProps) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    await onSubmit(password);
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div>
        <Label htmlFor="password">New Password</Label>
        <Input
          id="password"
          type="password"
          value={password}
          minLength={6}
          required
          autoComplete="new-password"
          onChange={e => setPassword(e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor="confirmPassword">Confirm Password</Label>
        <Input
          id="confirmPassword"
          type="password"
          value={confirmPassword}
          minLength={6}
          required
          autoComplete="new-password"
          onChange={e => setConfirmPassword(e.target.value)}
        />
      </div>
      <Button
        className="w-full bg-amber-500 hover:bg-amber-600"
        type="submit"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Saving..." : (isRecoveryMode ? "Reset Password" : "Set Password")}
      </Button>
    </form>
  );
};
